import { render, staticRenderFns } from "./ScopeOfPractice.vue?vue&type=template&id=cad4cfd8&scoped=true&"
import script from "./ScopeOfPractice.vue?vue&type=script&lang=js&"
export * from "./ScopeOfPractice.vue?vue&type=script&lang=js&"
import style0 from "./ScopeOfPractice.vue?vue&type=style&index=0&id=cad4cfd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad4cfd8",
  null
  
)

export default component.exports